
    import {useStore} from "@/store";
    import  reportMsgUt from "@/util/reportMsg";
    import {defineComponent, computed, watch, reactive, toRefs} from "vue";
    import {useRouter,useRoute} from "vue-router";

interface State {
    reportMsg: object;
    templateCode: string;
}
export default defineComponent({
    name: 'checkTitle',
    props: {
        itemCode: {
            type: String,
            default: ''
        },
        titleCont: {
            type: String,
            default: ''
        },
        count: {
            type: String,
            default: ''
        },
        allCount: {
            type: String,
            default: ''
        },
        checkStandardRouter: {
            type: String,
            default: ''
        },
        hasDefect: {
            type: Boolean,
            default: false
        },
        isExpanded: {
            type: Boolean,
            default: true
        },
    },
    emits: ['toggle'],
    setup(props, { emit }) {
        let state: State = reactive({
            reportMsg: {},
            templateCode: ''
        })
        state.reportMsg = reportMsgUt;

        let store = useStore()
        const router = useRouter()
        const {query} = useRoute();
        const { templateCode} = query;
        state.templateCode = String(templateCode);

        // 计算状态文本
        const statusText = computed(() => {
            const count = Number(props.count) || 0;
            if (props.hasDefect && count > 0) {
                return `${count} abnormal`;
            }
            return 'All Normal';
        });

        // 计算箭头图标
        const arrowIcon = computed(() => {
            if (props.isExpanded) {
                return require('@/assets/promiseFrame/arrowUp.png');
            }
            return require('@/assets/promiseFrame/arrowDown.png');
        });

        const handleToggle = () => {
            emit('toggle');
        };

        // 判断是否显示警告图标
        const showWarningIcon = computed(() => {
            return props.hasDefect && Number(props.count) > 0;
        });

        return {
            store,
            state,
            router,
            statusText,
            arrowIcon,
            handleToggle,
            showWarningIcon
        }
    }
})
